import React from 'react';
import {
  Formik,
  Field,
} from 'formik';
import i18n from 'i18next';
import * as Yup from 'yup';

import {
  Flex,
  Text,
} from 'web-styled';

import {
  Modal,
  Button,
  HelpText,
  TextField,
} from 'web-components';

const validationSchema = Yup.object().shape({
  email: Yup.string().when('invite', {
    is: true,
    then: Yup.string()
      .email('Email must be a valid email')
      .required('Email is required'),
    otherwise: Yup.string()
      .email('Email must be a valid email'),
  }),
  first_name: Yup.string()
    .required('First name is required'),
  last_name: Yup.string()
    .required('Last name is required'),
});

type Props = {
  isOpen: boolean;
  isLimitReached: boolean;
  onSubmit: { (data: any, actions: any): void };
  onRequestClose: { (): void };
};

const AddClient = ({
  isOpen,
  onSubmit,
  isLimitReached,
  onRequestClose,
}: Props) => (isLimitReached ? (
  <Modal
    title={i18n.t('add.client.modal.reached')}
    isOpen={isOpen}
    contentStyle={{ width: 600 }}
    onRequestClose={onRequestClose}
  >
    <Flex
      column
      width="100%"
      align="center"
      spacing={15}
    >
      <Text align="center">
        {i18n.t('add.client.modal.reached.body')}
      </Text>
      <Button
        ghost
        type="submit"
        spacing="large"
        appearance="primary"
        onClick={onRequestClose}
      >
        Ok
      </Button>
    </Flex>
  </Modal>
) : (
  <Modal
    title={i18n.t('add.client.modal.title')}
    isOpen={isOpen}
    contentStyle={{ width: 500 }}
    onRequestClose={onRequestClose}
  >
    <Formik
      initialValues={{
        email: '',
        first_name: '',
        last_name: '',
        invite: false,
      }}
      validateOnBlur={false}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(formikProps) => (
        <Flex
          column
          width="100%"
          as="form"
          spacing={10}
          onSubmit={formikProps.handleSubmit}
        >
          <Field
            autoFocus
            name="first_name"
            label="First Name *"
            value={formikProps.values.first_name}
            placeholder="e.g. John"
            component={TextField}
            autoComplete="off"
          />
          <Field
            name="last_name"
            label="Last Name *"
            value={formikProps.values.last_name}
            placeholder="e.g Smith"
            component={TextField}
            autoComplete="off"
          />
          <Field
            name="email"
            label={`${i18n.format(i18n.t('client'), 'cap')}'s email`}
            value={formikProps.values.email}
            placeholder="Email"
            component={TextField}
            autoComplete="off"
          />
          <Flex
            width="100%"
            margin="10px 0"
            justify="flex-end"
            spacing={20}
          >
            <Button
              ghost
              type="button"
              spacing="large"
              appearance="primary"
              isLoading={formikProps.isSubmitting && !formikProps.values.invite}
              isDisabled={formikProps.isSubmitting}
              onClick={() => {
                formikProps.setValues({
                  ...formikProps.values,
                  invite: false,
                });
                setTimeout(() => {
                  formikProps.submitForm();
                }, 10);
              }}
            >
              Invite later
            </Button>
            <Button
              type="button"
              appearance="success"
              onClick={() => {
                formikProps.setValues({
                  ...formikProps.values,
                  invite: true,
                });
                setTimeout(() => {
                  formikProps.submitForm();
                }, 10);
              }}
              spacing="large"
              isLoading={formikProps.isSubmitting && formikProps.values.invite}
              isDisabled={formikProps.isSubmitting}
            >
              Invite now
            </Button>
          </Flex>
          <hr />
          <HelpText size="13px" html={i18n.t('add.client.modal.help')} />
        </Flex>
      )}
    </Formik>
  </Modal>
));

export default AddClient;
